import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CompanyContainer from "../CompanyContainer";
import EditCompany from "../EditCompany";
import GHGProtocolModal from "../GHGProtocolModal";
import Sidebar from "../../CompanyDetail2/Sidebar";
import WaterComponent from "./Water";
import EnergyComponent from "./Energy";
import energySeparator from "../../../assets/design-revamp-company/company-detail-headers/energy-separator.svg";
import waterSeparator from "../../../assets/design-revamp-company/company-detail-headers/water-separator.svg";
import RegVehComponent from "./RegisteredVehicles";
import regVehSeparator from "../../../assets/design-revamp-company/company-detail-headers/reg-veh-separator.svg";
import StationaryComponent from "./CombustionFossilFuels";
import stationarySeparator from "../../../assets/design-revamp-company/company-detail-headers/stationary-separator.svg";
import EmissionGasComponent from "./EmissionGasses";
import emissionGasSeparator from "../../../assets/design-revamp-company/company-detail-headers/emission-gasses-separator.svg";
import TransportDeliveryComponent from "./TransportDelivery";
import transportDeliverySeparator from "../../../assets/design-revamp-company/company-detail-headers/transport-delivery-separator.svg";
import InventoryComponent from "./Inventory";
import inventorySeparator from "../../../assets/design-revamp-company/company-detail-headers/inventory-separator.svg";
import TravelComponent from "./Travel";
import travelSeparator from "../../../assets/design-revamp-company/company-detail-headers/business-travel-separator.svg";
import CommuteComponent from "./EmployeeCommute";
import commuteSeparator from "../../../assets/design-revamp-company/company-detail-headers/commute-separator.svg";
import RemoteComponent from "./RemoteWork";
import remoteSeparator from "../../../assets/design-revamp-company/company-detail-headers/remote-separator.svg";
import SurplusResourceComponent from "./SurplusResources";
import "./index.css";
import ProcessingIntermediateComponent from "./ProcessingSold";
import UseOfSoldComponent from "./UseOfSold";
import FinalTreatmentComponent from "./FinalTreatment";
import YFSLabelCompanyDetail from "../../CompanyYFSLabel/YFSLabelCompanyDetail";
import { getCompanySummary } from "../../../apis/ARDash/CompanySummary";
import { useUserAccess } from "../../../components/WriteAccessContext";

const CompanyDetailPage = () => {
  let { businessId } = useParams();
  const [mainBusinessId, setMainBusinessId] = useState("");
  const [companyData, setCompanyData] = useState(null);
  const { isShare } = useUserAccess();

  useEffect(() => {
    setMainBusinessId(localStorage.getItem("id_business"));
  }, []);

  useEffect(() => {
    if (window.location.href.includes("company") && businessId) {
      getCompanySummary({
        id: businessId,
        setObjects: setCompanyData,
        isShared: isShare,
      });
    }
  }, [businessId, isShare]);

  return (
    <>
      <Sidebar />
      <CompanyContainer>
        <EditCompany businessId={businessId} />
        <GHGProtocolModal />
        <div className="energy-relative">
          <EnergyComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={energySeparator}
            alt="Energy Separator"
            className="energy-separator"
          />
        </div>
        <div className="water-relative">
          <WaterComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={waterSeparator}
            alt="Water Separator"
            className="water-separator"
          />
        </div>
        <div className="regveh-relative">
          <RegVehComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={regVehSeparator}
            alt="Registered Vehicle Separator"
            className="reg-veh-separator"
          />
        </div>
        <div className="stationary-relative">
          <StationaryComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={stationarySeparator}
            alt="Stationary Separator"
            className="stationary-separator"
          />
        </div>
        <div className="emission-gas-relative">
          <EmissionGasComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={emissionGasSeparator}
            alt="Emission Gas Separator"
            className="emission-gas-separator"
          />
        </div>
        <div className="transport-delivery-relative">
          <TransportDeliveryComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={transportDeliverySeparator}
            alt="Transport Delivery Separator"
            className="transport-delivery-separator"
          />
        </div>
        <div className="inventory-relative">
          <InventoryComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={inventorySeparator}
            alt="Inventory Separator"
            className="inventory-separator"
          />
        </div>
        <div className="travel-relative">
          <TravelComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={travelSeparator}
            alt="Travel Separator"
            className="travel-separator"
          />
        </div>
        <div className="commute-relative">
          <CommuteComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={commuteSeparator}
            alt="Comute Separator"
            className="commute-separator"
          />
        </div>
        <div className="remote-relative">
          <RemoteComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
          <img
            src={remoteSeparator}
            alt="Remote Separator"
            className="remote-separator"
          />
        </div>
        <div>
          <SurplusResourceComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <ProcessingIntermediateComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <UseOfSoldComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <FinalTreatmentComponent
            businessId={businessId}
            mainBusinessId={mainBusinessId}
          />
        </div>

        <div style={{ marginTop: "30px" }}>
          {companyData && <YFSLabelCompanyDetail companyData={companyData} />}
        </div>
      </CompanyContainer>
    </>
  );
};

export default CompanyDetailPage;
